/*
 * Copyright (C) 2026 SimpliCity Digital Inc - All Rights Reserved
 */

export const initializeAppContext = () => {
    // console.log(process.env.REACT_APP_ENV);
    const SimpliCity = {
        isAdmin: process.env.REACT_APP_ENABLE_PREVIEW === "true",
        api: process.env.REACT_APP_SIMPLICITY_SDK_API_BASE_URL
    };
    const env = {
        ENV: process.env.REACT_APP_ENV,
        ENV_NAME: process.env.REACT_APP_ENV_NAME,
        ENV_KEY: process.env.REACT_APP_ENV_KEY,
        ENABLE_PREVIEW: process.env.REACT_APP_ENABLE_PREVIEW,
        SIMPLICITY_STAGE: process.env.REACT_APP_SIMPLICITY_STAGE,
        API_BASEURL: process.env.REACT_APP_SIMPLICITY_SDK_API_BASE_URL,
        GOOGLE_SITE_VERIFICATION: process.env.REACT_APP_GOOGLE_SITE_VERIFICATION,
        RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
        WEBSITE_URL: process.env.REACT_APP_SIMPLICITY_SDK_WEBSITE_URL,
        CONSOLE_URL: process.env.REACT_APP_SIMPLICITY_SDK_CONSOLE_URL,
        PREVIEW_URL: process.env.REACT_APP_SIMPLICITY_SDK_PREVIEW_URL,
        COOKIE_DOMAIN: process.env.REACT_APP_COOKIE_DOMAIN,
        LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
        LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
        // Logging
        LOG_SOURCE_TOKEN: process.env.REACT_APP_LOG_SOURCE_TOKEN,
        ENABLE_CONSOLE_LOG: process.env.REACT_APP_ENABLE_CONSOLE_LOG,
        ENABLE_HTTP_LOG: process.env.REACT_APP_ENABLE_HTTP_LOG,
        ENABLE_SAVE_PIPELINE_LOG: process.env.REACT_APP_ENABLE_SAVE_PIPELINE_LOG,
        ENABLE_WEBPAGE_LOG: process.env.REACT_APP_ENABLE_WEBPAGE_LOG,
    };
    window.SimpliCity = SimpliCity;
    return { env };
};
